import { Component } from '@angular/core';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent {
  // bread crumb items
  breadCrumbItems!: Array<{}>;

  ngOnInit(): void {
   this.breadCrumbItems = [
      { label: 'Users' },
      { label: 'User Management', active: true }
    ]; 
  }
}
